export enum PROGRESSION_SCHEMA_VALIDATIONS {
  DEVELOPER_KEY_MAX_LENGTH = 255,
  DESCRIPTION_MAX_LENGTH = 1000,
  DISPLAY_NAME_MAX_LENGTH = 255,
  DEVELOPER_VALUE_MAX_LENGTH = 65535,
  DEFAULT_QUANTITY_MAX_LENGTH = 38, // max num supported by dynamo db for in game items
}
